"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CALL_API = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var middleware = function middleware(result, callback) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  callback(result);

  if (error) {
    return Promise.reject(result);
  }

  return Promise.resolve(result);
}; // the key on the action object where the details of the API call are stored


var CALL_API = 'CALL_API';
exports.CALL_API = CALL_API;

var createApiMiddleware = function createApiMiddleware(authGuard) {
  return function () {
    return function (next) {
      return function (action) {
        // get the API call details from the action object
        var callAPI = action[CALL_API]; // if the CALL_API property is not found on the object, it is not an API action, and we can next()
        // to pass it on to the next middleware

        if (typeof callAPI === 'undefined') {
          return next(action);
        } // destructure the properties of the API action


        var types = callAPI.types,
            request = callAPI.request,
            misc = callAPI.misc,
            _callAPI$callback = callAPI.callback,
            callback = _callAPI$callback === void 0 ? function () {} : _callAPI$callback,
            _callAPI$errorCallbac = callAPI.errorCallback,
            errorCallback = _callAPI$errorCallbac === void 0 ? function () {} : _callAPI$errorCallbac; // confirm we have the expected number of types

        if (!Array.isArray(types) || types.length !== 3) {
          throw new Error('Expected an array of three action types.');
        }

        if (!types.every(function (type) {
          return typeof type === 'string';
        })) {
          throw new Error('Expected action types to be strings.');
        }

        var actionWith = function actionWith(data) {
          var finalAction = Object.assign({}, action, data);
          delete finalAction[CALL_API];
          return finalAction;
        }; // destructure the specific action types


        var _types = _slicedToArray(types, 3),
            requestType = _types[0],
            successType = _types[1],
            failureType = _types[2]; // next() an action indicating the request has started


        next(actionWith({
          type: requestType
        }));

        if (authGuard) {
          // if we are using authGuard, pass the request, success handlers and failure handlers to
          // the authGuard function
          return authGuard( // request fn
          function () {
            return request();
          }, // success handler
          function (response) {
            next(actionWith({
              type: successType,
              response: response || {},
              misc: misc
            }));

            if (callback) {
              middleware(response, callback);
            }
          }, // error handler
          function (error) {
            next(actionWith({
              type: failureType,
              response: _lodash.default.get(error, 'response.data', {}),
              misc: misc
            }));
            if (errorCallback) middleware(error, errorCallback, true);
          });
        } // if we are not using authGuard, just make the request and then handle the success/failure


        return request().then(function (response) {
          // if we succeed, next() an action with the successType
          next(actionWith({
            type: successType,
            response: response || {},
            misc: misc
          }));
          if (callback) middleware(response, callback);
        }) // if we throw, next() an action with the failureType
        .catch(function (error) {
          next(actionWith({
            type: failureType,
            response: _lodash.default.get(error, 'response.data', {}),
            misc: misc
          }));
          if (errorCallback) middleware(error, errorCallback, true);
        });
      };
    };
  };
};

var _default = createApiMiddleware;
exports.default = _default;